import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "premiumText", "freeText", "acceptButton", "declineButton"]

  connect() {
    console.log("Premium toggle controller connected")
    this.updateDisplay()
  }

  selectAccept(event) {
    event.preventDefault()
    console.log("Accept clicked")
    this.checkboxTarget.checked = true
    this.updateDisplay()
  }

  selectDecline(event) {
    event.preventDefault()
    console.log("Decline clicked")
    this.checkboxTarget.checked = false
    this.updateDisplay()
  }

  updateDisplay() {
    const isAccepted = this.checkboxTarget.checked
    console.log("Updating display, isAccepted:", isAccepted)
    
    if (isAccepted) {
      // ACCEPT selected - Premium trial
      this.premiumTextTarget.classList.remove("hidden")
      this.freeTextTarget.classList.add("hidden")
      
      // Style ACCEPT button as active (gradient)
      this.acceptButtonTarget.className = "w-full p-6 rounded-xl border-2 transition-all duration-300 bg-gradient-to-r from-green-500 to-blue-500 border-green-400 text-white shadow-lg transform hover:scale-105"
      
      // Style DECLINE button as inactive (gray)
      this.declineButtonTarget.className = "w-full p-6 rounded-xl border-2 transition-all duration-300 bg-gray-100 border-gray-300 text-gray-600 hover:bg-gray-200"
      
    } else {
      // DECLINE selected - Free account
      this.premiumTextTarget.classList.add("hidden")
      this.freeTextTarget.classList.remove("hidden")
      
      // Style ACCEPT button as inactive (gray)
      this.acceptButtonTarget.className = "w-full p-6 rounded-xl border-2 transition-all duration-300 bg-gray-100 border-gray-300 text-gray-600 hover:bg-gray-200"
      
      // Style DECLINE button as active (gradient)
      this.declineButtonTarget.className = "w-full p-6 rounded-xl border-2 transition-all duration-300 bg-gradient-to-r from-red-500 to-orange-500 border-red-400 text-white shadow-lg transform hover:scale-105"
    }
  }
}